module.exports = __webpack_public_path__ + "static/img/royalty-free-wings.195eea8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/royalty-free-wings.jpg
// module id = VgYn
// module chunks = 1